import React, { createContext, useState, useContext } from 'react';


// Create the context
const BottomNavbarContext = createContext();

// Create a provider component
export const BottomNavbarProvider = ({ children }) => {
  const [isHomeActive, setIsHomeActive] = useState(true);
  const [isTestsActive, setIsTestsActive] = useState(false);
  const [isPackagesActive, setIsPackagesActive] = useState(false);
  const [isRadiologyActive, setIsRadiologyActive] = useState(false);
  const [isProfileActive, setIsProfileActive] = useState(false);

  // Function to activate a specific tab and deactivate others
  const activateTab = (tabName) => {
    setIsHomeActive(tabName === 'home');
    setIsTestsActive(tabName === 'tests');
    setIsPackagesActive(tabName === 'packages');
    setIsRadiologyActive(tabName === 'radiology');
    setIsProfileActive(tabName === 'profile');
  };

  // Values to be provided to consumers
  const value = {
    isHomeActive,
    isTestsActive,
    isPackagesActive,
    isRadiologyActive,
    isProfileActive,
    setIsHomeActive,
    setIsTestsActive,
    setIsPackagesActive,
    setIsRadiologyActive,
    setIsProfileActive,
    activateTab,
  };

  return <BottomNavbarContext.Provider value={value}>{children}</BottomNavbarContext.Provider>;
};

export const useBottomNavbarContext = () => useContext(BottomNavbarContext);

export default BottomNavbarProvider;